module.exports = __webpack_public_path__ + "img/nepal.69c57d63.svg";